export const FORM_ERROR = {
  REQUIRED: 'Required',
  INVALID_EMAIL: 'Invalid email',
}

export const LIFE_FORMIK_KEYS = {
  GENDER: 'gender',
  INSURED_RELATION: 'insuredRelation',
  EXISTINGPOLICYCLAIM: 'existingPolicyClaim',
}
